import React, { useRef } from 'react';
import i18n from '@i18next/i18n';
import style from './style.less';
import { TOOLBAR_FILLCOLOR, TOOLBAR_DROPDOWN } from '@src/framework/editor/src/img/pageIndex';
import classNames from 'classnames';
import {
    ColorPickerType,
    ColorPickerActionType,
    ColorSourceType,
} from '@src/js/common/ark-extensions/dc-components/color-picker/type';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import ColorPickerContainer from '@src/js/common/ark-extensions/dc-components/color-picker/color-picker-container';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

interface Props {
    color?: ITDColor | null;
    disabled?: boolean;
    onChange: (color: ITDColor | null, source) => void;
}

const defaultColor = '#000';
export default function ColorPanel(props: Props) {
    const { color, disabled = false, onChange } = props;
    const iconRef = useRef<HTMLDivElement>(null);

    const getColorPickerDropdownContent = (): React.ReactElement | undefined => {
        if (disabled) {
            return undefined;
        }

        return <ColorPickerContainer
            colorPickerType={ColorPickerType.StandardPC}
            selectedTdColor={color || undefined}
            onColorChange={(tdColor, source) => {
                onChange(tdColor, source);
            }}
            actions={[{
                text: i18n.t('自动'),
                position: ColorPickerActionType.Top,
                onClick: () => {
                    onChange(null, ColorSourceType.Theme);
                },
            }]}
        />;
    };

    return (
        <div
            className={style['color-panel']}
        >
            <div className={style['color-panel-label']}>
                {i18n.t('颜色')}：
            </div>
            <Dropdown
                disabled={disabled}
                dropContent={getColorPickerDropdownContent()}
                containerFollowVisible
            >
                <div
                    className={classNames({
                        [style['color-panel-dropdown-container']]: true,
                    })}
                    ref={iconRef}
                >
                    <div className={style['color-icon-container']}>
                        <img src={TOOLBAR_FILLCOLOR} alt="" />
                        <div className={style['color-bar']} style={{ backgroundColor: color?.srgb_color || defaultColor }}></div>
                    </div>
                    <div className={style['color-panel-dropdown']}>
                        <img src={TOOLBAR_DROPDOWN} alt="" />
                    </div>
                </div>
            </Dropdown>
        </div>
    );
}
